import { render, staticRenderFns } from "./CertificationArticleListPage.vue?vue&type=template&id=03e3487a&scoped=true"
import script from "./CertificationArticleListPage.vue?vue&type=script&lang=js"
export * from "./CertificationArticleListPage.vue?vue&type=script&lang=js"
import style0 from "./CertificationArticleListPage.vue?vue&type=style&index=0&id=03e3487a&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "03e3487a",
  null
  
)

export default component.exports